import { render, staticRenderFns } from "./CostoTotalMP.vue?vue&type=template&id=ac971f16&"
import script from "./CostoTotalMP.vue?vue&type=script&lang=js&"
export * from "./CostoTotalMP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports